import { useGate, useStore, useStoreMap } from 'effector-react'
import { regionModel, Form } from '~/entities/common/Taxipark/Regions'
import { usePermissions } from '~/entities/common/viewer'
import { timezoneCodeLabels } from '~/shared/config/constants'
import { formSubmitted, Gate, $region, regionUpdateFx } from './model'

type EditRegionProps = {
  regionId: string
}

export function EditRegion({ regionId }: EditRegionProps) {
  useGate(Gate, { regionId })
  const { canRegionsUpdate } = usePermissions()

  const isLoading = useStore(regionModel.requestFx.pending)
  const isSaving = useStore(regionUpdateFx.pending)

  const defaultValues = useStoreMap($region, (region) => {
    const timezone = region?.getTimezone()
    return {
      name: region?.getName(),
      timezone: timezone
        ? {
            id: timezone,
            label: timezoneCodeLabels[timezone],
          }
        : null,
    }
  })

  return (
    <Form
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSuccess={formSubmitted}
      isSubmitting={isSaving}
      canEdit={canRegionsUpdate}
    />
  )
}
